export default function fetchDates(from, to) {
  return {
    type: "FETCH_DATES",
    dates: { from, to }
  };
}
